// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import { frontmatter as fm0, toc as t0, demoIndex as dmi0 } from '/home/runner/work/dialog/dialog/docs/demo/multiple-Portal.md?type=frontmatter';
import { frontmatter as fm1, toc as t1, demoIndex as dmi1 } from '/home/runner/work/dialog/dialog/docs/demo/with-portal.md?type=frontmatter';
import { frontmatter as fm2, toc as t2, demoIndex as dmi2 } from '/home/runner/work/dialog/dialog/docs/demo/ant-design.md?type=frontmatter';
import { frontmatter as fm3, toc as t3, demoIndex as dmi3 } from '/home/runner/work/dialog/dialog/docs/demo/bootstrap.md?type=frontmatter';
import { frontmatter as fm4, toc as t4, demoIndex as dmi4 } from '/home/runner/work/dialog/dialog/docs/demo/draggable.md?type=frontmatter';
import { frontmatter as fm5, toc as t5, demoIndex as dmi5 } from '/home/runner/work/dialog/dialog/docs/changelog.md?type=frontmatter';
import { frontmatter as fm6, toc as t6, demoIndex as dmi6 } from '/home/runner/work/dialog/dialog/docs/demo/pure.md?type=frontmatter';
import { frontmatter as fm7, toc as t7, demoIndex as dmi7 } from '/home/runner/work/dialog/dialog/docs/index.md?type=frontmatter';

export const filesMeta = {
  'docs/demo/multiple-Portal': {
    frontmatter: fm0,
    toc: t0,
    demoIndex: dmi0,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/home/runner/work/dialog/dialog/docs/demo/multiple-Portal.md?type=text'),
  },
  'docs/demo/with-portal': {
    frontmatter: fm1,
    toc: t1,
    demoIndex: dmi1,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/home/runner/work/dialog/dialog/docs/demo/with-portal.md?type=text'),
  },
  'docs/demo/ant-design': {
    frontmatter: fm2,
    toc: t2,
    demoIndex: dmi2,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/home/runner/work/dialog/dialog/docs/demo/ant-design.md?type=text'),
  },
  'docs/demo/bootstrap': {
    frontmatter: fm3,
    toc: t3,
    demoIndex: dmi3,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/home/runner/work/dialog/dialog/docs/demo/bootstrap.md?type=text'),
  },
  'docs/demo/draggable': {
    frontmatter: fm4,
    toc: t4,
    demoIndex: dmi4,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/home/runner/work/dialog/dialog/docs/demo/draggable.md?type=text'),
  },
  'docs/changelog': {
    frontmatter: fm5,
    toc: t5,
    demoIndex: dmi5,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/home/runner/work/dialog/dialog/docs/changelog.md?type=text'),
  },
  'docs/demo/pure': {
    frontmatter: fm6,
    toc: t6,
    demoIndex: dmi6,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/home/runner/work/dialog/dialog/docs/demo/pure.md?type=text'),
  },
  'docs/index': {
    frontmatter: fm7,
    toc: t7,
    demoIndex: dmi7,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/home/runner/work/dialog/dialog/docs/index.md?type=text'),
  },
}

export { tabs as tabsMeta } from './tabs';
